// extracted by mini-css-extract-plugin
module.exports = {"jobSearchTopHeader":"jobSearchTopHeader","jobSearchTopHeader__title":"jobSearchTopHeader__title","jobSearchTopHeader__jobCount":"jobSearchTopHeader__jobCount"};